import { useMemo } from 'react';
import type { SearchBiomarkersRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { useSearchBiomarkersQuery } from '@/entities/labs';

export interface BiomarkerSearchInput {
  name: string;
  labId?: string | null;
}

export function useBiomarkerSearch(input: BiomarkerSearchInput | undefined) {
  const filters = useMemo((): SearchBiomarkersRequestT | undefined => {
    const name = input?.name?.trim() ?? '';
    if (name === '') {
      return undefined;
    }

    const labId = input?.labId ?? null;
    return {
      name,
      aLaCarteEnabled: true,
      page: 1,
      size: 50,
      ...(labId ? { labId: [labId] } : {}),
    };
  }, [input?.labId, input?.name]);

  return useSearchBiomarkersQuery(filters);
}
